// "Schedule 4, clause 9.3" when the amendment names a part other than main;
// a stored "part/" prefix on the reference is dropped
export default function formatClauseLabel(
  reference: string | undefined,
  section: string | undefined,
  withClauseWord = true,
): string {
  const bare = (reference ?? "").slice((reference ?? "").lastIndexOf("/") + 1);
  const part = section && section.toLowerCase() !== "main" ? section : "";
  if (!bare) {
    return part || "General";
  }
  if (!part) {
    return withClauseWord ? `Clause ${bare}` : bare;
  }
  return withClauseWord ? `${part}, Clause ${bare}` : `${part}, ${bare}`;
}
